import { io } from 'socket.io-client';

let socket;
let connecting = false;
let currentToken = null;
const eventCallbacks = new Map();

const createSocketMiddleware = () => {

  return store => next => action => {
    switch (action?.type) {
      case 'socket/connect':
        const { url, auth } = action.payload;
        const nextToken = auth?.token;

        if (socket && socket.connected && currentToken === nextToken) {
          console.log('socket already connected - skip');
          break;
        }

        if (connecting) {
          console.log('socket already connecting - skip');
          break;
        }

        connecting = true;
        currentToken = nextToken;

        if (socket && socket.connected) {
          socket.disconnect();
          socket = null;
        }

        store.dispatch({ type: 'socket/connecting' });
        socket = io(url, {
          auth: {
            token: nextToken
          },
          transports: ['websocket'],
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          reconnectionAttempts: 10
        });

        socket.io.on('reconnect_attempt', (attempt) => {
          console.log('reconnect attempt', attempt);
        });

        socket.io.on('reconnect_failed', () => {
          console.log('reconnect failed');
        });

        socket.on('connect', () => {
          connecting = false;
          const socketId = socket.id;
          socket.emit('PMS_CONNECT', socketId)
          console.log(`socket connected`);
          store.dispatch({ type: 'socket/connected', payload: socketId });
        });

        socket.on('disconnect', (reason) => {
          console.log('socket disconnected: ', reason);
          store.dispatch({ type: 'socket/disconnected' });
        });

        socket.on('error', (error) => {

          console.error('socket error', error);
          connecting = false;

          store.dispatch({ 
            type: 'socket/error',
            payload: error 
          });
        });

        socket.onAny((event, data) => {
          const callbacks = eventCallbacks.get(event);

          if (callbacks) {
            callbacks.forEach((cb) => {
              try {
                cb(data);
              } catch (err) {
                console.error('socket callback error', err);
              }
            });
          }
        });

        break;

      case 'socket/disconnect':
        if (socket) {
          socket.disconnect();
          socket = null;
        }

        connecting = false;
        currentToken = null;
        
        eventCallbacks.clear();

        break;

      case 'socket/emit':
        if (socket && socket.connected) {
          const { event, data } = action.payload;
          socket.emit(event, data);
        } else {
          console.error('Socket is not connected');
        }
        break;

      case 'socket/on': {
        const { event, callback } = action.payload;

        if (!eventCallbacks.has(event)) {
          eventCallbacks.set(event, new Set());
        }

        eventCallbacks.get(event).add(callback);
        break;
      }
  
      case 'socket/off': {
        const { event, callback } = action.payload;

        const callbacks = eventCallbacks.get(event);

        if (!callbacks) break;

        callbacks.delete(callback);

        if (callbacks.size === 0) {
          eventCallbacks.delete(event);
        }

        break;
      }

      default:
        break;
    }

    return next(action);
  };
};

export default createSocketMiddleware;